//------------------
// get rune changes
//------------------
export default function getRuneChanges({original, now}) {
  // -----------------------
  // declare changes object
  // -----------------------
  let changes = {}
  // -------------------
  // loop original keys
  // -------------------
  for (const key in original) {
    // -------------
    // where change
    // -------------
    if (original[key] !== now[key]) {
      // -------------
      // store change
      // -------------
      changes[key] = { from: original[key], to: now[key] }
    }
  }
  return changes
}
